import React from 'react';
import Sidebar from '../Components/Sidebar';

const ReportScreen = () => {
    
    return (
        <>
            <div className="container " style={{ margin: '0px', padding: '0px' }}>
                <div className="left-panel">
                <Sidebar defaultValue="SelectReport"/>
                     </div>
                <div className="right-panel">

                </div>
            </div>
        </>
    )
}

export default ReportScreen
